import axios from "axios";
import {
    IAlertAnalytics,
    IAnalyticsRequest,
    IAnalyticsResponse,
    IAgency,
    ICompetitionOption,
    INaics,
    IPsc,
    IRankedVendor,
    ISetAside,
    IState
} from "./Analytics.types";
import moment from 'moment'

export default class AnalyticsApi {

    static async getPreviousDayDashboardForUser({queryKey}) {
        let yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
        return await AnalyticsApi.getDashboardForUserByDate({queryKey: [...queryKey, yesterday]})
    }

    static async getDashboardForUserByDate({queryKey}) {
        //eslint-disable-next-line
        const [_key, userId, alert_for_date] = queryKey;
        try {
            let res = await axios.get(`/analytics/dashboard/${userId}`, {params: {alert_for_date}});
            if (res) {
                return res.data as IAlertAnalytics;
            }
        } catch (e) {
            console.error('Error getting dashboard analytics', e.message);
        }
    }

    static async getTopAgencies({queryKey}) {
        //eslint-disable-next-line
        const request: IAnalyticsRequest = queryKey[1];
        try {
            let res = await axios.post(`/analytics/top-agencies`, request);
            if (res) {
                return res.data as IAnalyticsResponse<IAgency>;
            }
        } catch (e) {
            console.error('Error getting top-agencies analytics', e.message);
        }
    }

    static async getTopCompetitionOptions({queryKey}) {
        //eslint-disable-next-line
        const request: IAnalyticsRequest = queryKey[1];
        try {
            let res = await axios.post(`/analytics/top-competition-options`, request);
            if (res) {
                return res.data as IAnalyticsResponse<ICompetitionOption>;
            }
        } catch (e) {
            console.error('Error getting top-competition-options analytics', e.message);
        }
    }

    static async getTopNaics({queryKey}) {
        //eslint-disable-next-line
        const request: IAnalyticsRequest = queryKey[1];
        try {
            let res = await axios.post(`/analytics/top-naics`, request);
            if (res) {
                return res.data as IAnalyticsResponse<INaics>;
            }
        } catch (e) {
            console.error('Error getting top-naics analytics', e.message);
        }
    }

    static async getTopPsc({queryKey}) {
        //eslint-disable-next-line
        const request: IAnalyticsRequest = queryKey[1];
        try {
            let res = await axios.post(`/analytics/top-psc`, request);
            if (res) {
                return res.data as IAnalyticsResponse<IPsc>;
            }
        } catch (e) {
            console.error('Error getting top-psc analytics', e.message);
        }
    }

    static async getRankedVendors({queryKey}) {
        //eslint-disable-next-line
        const request: IAnalyticsRequest = queryKey[1];
        try {
            let res = await axios.post(`/analytics/ranked-vendors`, request);
            if (res) {
                return res.data as IAnalyticsResponse<IRankedVendor>;
            }
        } catch (e) {
            console.error('Error getting ranked-vendors analytics', e.message);
        }
    }

    static async getTopSetAside({queryKey}) {
        //eslint-disable-next-line
        const request: IAnalyticsRequest = queryKey[1];
        try {
            let res = await axios.post(`/analytics/top-set-aside`, request);
            if (res) {
                return res.data as IAnalyticsResponse<ISetAside>;
            }
        } catch (e) {
            console.error('Error getting top-set-aside analytics', e.message);
        }
    }

    static async getTopStates({queryKey}) {
        //eslint-disable-next-line
        const request: IAnalyticsRequest = queryKey[1];
        try {
            let res = await axios.post(`/analytics/top-states`, request);
            if (res) {
                return res.data as IAnalyticsResponse<IState>;
            }
        } catch (e) {
            console.error('Error getting top-states analytics', e.message);
        }
    }

    static async getWeeklyTopAgencies({queryKey}) {
        //eslint-disable-next-line
        const [_key, userId] = queryKey;
        try {
            let res = await axios.post(`/analytics/top-agencies/weekly`, {userId});
            if (res) {
                return res.data as IAnalyticsResponse<IAgency>;
            }
        } catch (e) {
            console.error('Error getting weekly top-agencies analytics', e.message);
        }
    }

    static async getWeeklyTopCompetitionOptions({queryKey}) {
        //eslint-disable-next-line
        const [_key, userId] = queryKey;
        try {
            let res = await axios.post(`/analytics/top-competition-options/weekly`, {userId});
            if (res) {
                return res.data as IAnalyticsResponse<ICompetitionOption>;
            }
        } catch (e) {
            console.error('Error getting weekly top-competition-options analytics', e.message);
        }
    }

    static async getWeeklyTopNaics({queryKey}) {
        //eslint-disable-next-line
        const [_key, userId] = queryKey;
        try {
            let res = await axios.post(`/analytics/top-naics/weekly`, {userId});
            if (res) {
                return res.data as IAnalyticsResponse<INaics>;
            }
        } catch (e) {
            console.error('Error getting weekly top-naics analytics', e.message);
        }
    }

    static async getWeeklyTopPsc({queryKey}) {
        //eslint-disable-next-line
        const [_key, userId] = queryKey;
        try {
            let res = await axios.post(`/analytics/top-psc/weekly`, {userId});
            if (res) {
                return res.data as IAnalyticsResponse<IPsc>;
            }
        } catch (e) {
            console.error('Error getting weekly top-psc analytics', e.message);
        }
    }

    static async getWeeklyRankedVendors({queryKey}) {
        //eslint-disable-next-line
        const [_key, userId] = queryKey;
        try {
            let res = await axios.post(`/analytics/ranked-vendors/weekly`, {userId});
            if (res) {
                return res.data as IAnalyticsResponse<IRankedVendor>;
            }
        } catch (e) {
            console.error('Error getting weekly ranked-vendors analytics', e.message);
        }
    }

    static async getWeeklyTopSetAside({queryKey}) {
        //eslint-disable-next-line
        const [_key, userId] = queryKey;
        try {
            let res = await axios.post(`/analytics/top-set-aside/weekly`, {userId});
            if (res) {
                return res.data as IAnalyticsResponse<ISetAside>;
            }
        } catch (e) {
            console.error('Error getting weekly top-set-aside analytics', e.message);
        }
    }

    static async getWeeklyTopStates({queryKey}) {
        //eslint-disable-next-line
        const [_key, userId] = queryKey;
        try {
            let res = await axios.post(`/analytics/top-states/weekly`, {userId});
            if (res) {
                return res.data as IAnalyticsResponse<IState>;
            }
        } catch (e) {
            console.error('Error getting weekly top-states analytics', e.message);
        }
    }

}